import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../../api";

interface UnbindUserGroupFromOrgParams {
  groupId: string;
  orgId: string;
}

export function useUnbindUserGroupFromOrg() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ groupId, orgId }: UnbindUserGroupFromOrgParams) =>
      api.unbindUserGroupFromOrg(groupId, orgId),
    onSuccess: (_data, { groupId }) => {
      queryClient.invalidateQueries({
        queryKey: ["user-groups", groupId, "org-bindings"],
      });
    },
  });
}
